import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.834 3.988a.75.75 0 000 1.5h15a1.5 1.5 0 011.5 1.5v2.488a.75.75 0 01-1.5 0V6.989h-15a2.25 2.25 0 01-.75-.128v9.878a.75.75 0 00.75.75h6.335a.75.75 0 010 1.5H4.834a2.25 2.25 0 01-2.25-2.25v-12a2.25 2.25 0 012.25-2.25h12.75a.75.75 0 010 1.5H4.834z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.919 13.227v7.5h6v-5.315l-2.186-2.185h-3.814zm-1.17-1.17c.21-.212.496-.33.795-.33h4.5a.75.75 0 01.53.22l2.625 2.624c.14.14.22.332.22.53v6a1.125 1.125 0 01-1.125 1.126h-6.75a1.125 1.125 0 01-1.125-1.125v-8.25c0-.299.118-.585.33-.796z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M19.044 11.727a.75.75 0 01.75.75v1.875h1.875a.75.75 0 110 1.5h-2.625a.75.75 0 01-.75-.75v-2.625a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
